import { FormBuilder, Validators } from "@angular/forms";
import { ProductFormDetailMapping } from "../mapping/product-form-mapping";
import { ProductMapping } from "../../../../../../lib-core-shared/src/lib/mappings/product/product-create/product-mappings";
import { ICommodity, IProductModel } from "../../../../../../lib-core-shared/src/lib/models/product/product.model";
import { PrefixService } from "lib-core-shared";

export class ProductDetailsViewModel implements IProductModel {
    productDetailFormMapping: ProductFormDetailMapping;
    productDetailsDtoMapping: ProductMapping;
    constructor(private readonly fb: FormBuilder, private prefixService: PrefixService) {
        this.productDetailsDtoMapping = new ProductMapping();
        this.productDetailFormMapping = new ProductFormDetailMapping(this.prefixService);
    }
    id!: number;
    partNumber!: string;
    basePartNumber!: string;
    commodity!: ICommodity;
    countryOfOriginCode!: string;
    taxRateCategoryId!: number;

    public form = () => this.fb.group({
        partNumber: [null, Validators.required],
        basePartNumber: [null],
        englishShortTitle: [null, Validators.required],
        countryOfOriginCode: [null, Validators.required],
        masterProductSatus: [null, Validators.required],
        componentStatus: [null, Validators.required],
        ukCommodityCode: [null, Validators.required],
        usCommodityCode: [null, Validators.required],
        ukCommodityNumber: [null],
        usCommodityNumber: [null],
        taxonomyCode: [null, Validators.required],
        taxRateCategory: [null, Validators.required],
        discountCategories: [null, Validators.required],
        productType: [null, Validators.required],
    });
}